import { render } from "./FloatMenu.vue?vue&type=template&id=4c03cdd3&scoped=true"
import script from "./FloatMenu.vue?vue&type=script&lang=js"
export * from "./FloatMenu.vue?vue&type=script&lang=js"

import "./FloatMenu.vue?vue&type=style&index=0&id=4c03cdd3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c03cdd3"]])

export default __exports__